import api from './api';
import { publicApi } from './api';

export interface Job {
  id: number;
  title: string;
  company: string;
  company_logo: string | null;
  location: string;
  type: 'full-time' | 'part-time' | 'freelance';
  status: 'open' | 'closed';
  description: string;
  requirements: string[];
  posted_date: string;
  applicants_count: number;
  created_by: number;
}

export const jobService = {
  async list(params?: { status?: string; type?: string }) {
    const { data } = await publicApi.get<{ data: Job[] }>('/jobs', { params });
    return Array.isArray(data) ? data : (data.data || data);
  },

  async get(id: number) {
    const { data } = await publicApi.get<Job>(`/jobs/${id}`);
    return data;
  },

  async create(payload: Partial<Job>) {
    const { data } = await api.post<Job>('/jobs', payload);
    return data;
  },

  async update(id: number, payload: Partial<Job>) {
    const { data } = await api.put<Job>(`/jobs/${id}`, payload);
    return data;
  },

  async delete(id: number) {
    await api.delete(`/jobs/${id}`);
  },

  async toggleStatus(id: number) {
    const { data } = await api.patch<Job>(`/jobs/${id}/toggle-status`);
    return data;
  },
};
